import { Text, View } from '@react-pdf/renderer';
import { type LucideIcon } from 'lucide-react';
import { type ReactElement } from 'react';
import { PDF_STYLES } from '../../styles';
import { LucidePdfIcon, PDF_ICON_SIZE } from '../PdfIcon';

interface IconTextProps {
  icon: LucideIcon;
  title: string;
  description?: string;
}

export const IconText = ({ icon, title, description }: IconTextProps): ReactElement => (
  <View style={PDF_STYLES.iconRow}>
    <LucidePdfIcon icon={icon} size={PDF_ICON_SIZE.sm} />
    <View style={PDF_STYLES.iconRowText}>
      <Text style={PDF_STYLES.iconRowTitle}>{title}</Text>
      {description ? <Text style={PDF_STYLES.iconRowDescription}>{description}</Text> : null}
    </View>
  </View>
);
